import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { IoMdPeople } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";

const route = all_routes;

export const SidebarData = [
  {
    // label: "CRM",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.dashboard,
      },
      {
        label: "Speak To Lead",
        icon: "ti ti-medal",
        submenu: false,
        showSubRoute: false,
        link: route.scriptGenerator,
        // submenuItems: [
        //   // { label: "Calls", link: route.allCalls, icon: <IoMdPeople /> },
        //   {
        //     label: "Script",
        //     link: route.scriptGenerator,
        //     icon: <IoMdPeople />,
        //   },
        // ],
      },
      // {
      //   label: "Agents",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.agents,
      // },
      // {
      //   label: "Groups",
      //   icon: "bi bi-map",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.groups,
      // },

      {
        label: "Database",
        icon: "ti ti-database",
        submenu: false,
        link: route.contactList,
        showSubRoute: false,

      },
      // {
      //   label: "FAQ",
      //   icon: "ti ti-user-up",
      //   submenu: false,
      //   link: route.contactFaq,
      //   showSubRoute: false,
      // },
      {
        label: "Leads",
        icon: "ti ti-users",
        submenu: false,
        showSubRoute: false,
        link: route.leads,
        onClick: () => console.log("Leads Clicked"),
      },
      {
        label: "Calendar",
        icon: "ti ti-calendar",
        submenu: false,
        showSubRoute: false,
        link: route.calendar,
      },
      {
        label: "Whatsapp",
        icon: "ti ti-brand-whatsapp",
        submenu: true,
        showSubRoute: true,
        // link: route.whatsapp,
        submenuItems: [
          {
            label: "Chat",
            link: route.whatsapp,
            icon: <IoMdPeople />,
          },
          {
            label: "History",
            link: route.whatsappHistory,
            icon: <IoMdPeople />,
          },
          {
            label: "Campaigns",
            link: route.wabaCampaigns,
            icon: <IoMdPeople />,
          },
          {
            label: "Templates",
            link: route.wabaTemplates,
            icon: <IoMdPeople />,
          },
          {
            label: "Settings",
            link: route.wabaSetting,
            icon: <IoMdPeople />,
          },
          {
            label: "Automation",
            link: route.wabaAutomation,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Settings",
        icon: "ti ti-settings",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Profile Settings",
            link: route.profile,
            icon: <IoMdPeople />,
          },
          {
            label: "Dialer Settings",
            link: route.callerSettings,
            icon: <IoMdPeople />,
          },
          {
            label: "Security",
            link: route.security,
            icon: <IoMdPeople />,
          },
          {
            label: "Agents",
            link: route.agents,
            icon: <IoMdPeople />,
          },
          {
            label: "Groups",
            link: route.groups,
            icon: <IoMdPeople />,
          },
          {
            label: "Email Templates",
            link: `${route.templates}#emailTemplates`,
            icon: <IoMdPeople />,
          },
          {
            label: "Manage Statuses",
            link: route.contact_statuses,
            icon: <IoMdPeople />,
          },
          {
            label: "FAQs",
            link: route.contactFaq,
            icon: <IoMdPeople />,
          },
        ],
      },

      {
        label: "Sync & Integration",
        icon: "ti ti-reload",
        submenu: false,
        showSubRoute: false,
        link: route.syncAndIntegration,
      },
      {
        label: "Call Recordings",
        icon: "ti ti-phone",
        submenu: false,
        showSubRoute: false,
        link: route.callAndRecording,
      },

      {
        label: "Import Contacts",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.importAndExport,
      },

      {
        label: "API Docs",
        icon: "ti ti-cloud-cog",
        submenu: false,
        showSubRoute: false,
        link: route.api,
      },

      {
        label: "Phone Numbers",
        icon: "ti ti-phone-plus",
        submenu: true,
        showSubRoute: true,
        submenuItems: [
          { label: "Browse Numbers", link: route.didBrowseNumbers,  icon: <IoMdPeople /> },
          { label: "Number Cart",    link: route.didNumberCart,     icon: <IoMdPeople /> },
          { label: "My Numbers",     link: route.didMyNumbers,      icon: <IoMdPeople /> },
          { label: "Assign Numbers", link: route.didAssignNumbers,  icon: <IoMdPeople /> },
          { label: "KYC Documents",  link: route.didKycDocuments,   icon: <IoMdPeople /> },
          { label: "Call Rates",     link: route.callRates,         icon: <IoMdPeople /> },
        ],
      },

      {
        label: "Plans & Billing",
        icon: "ti ti-crown",
        submenu: true,
        showSubRoute: true,
        submenuItems: [
          {
            label: "Upgrade Plan",
            link: route.upgradePlan,
            icon: <IoMdPeople />,
          },
          {
            label: "Billing & Invoices",
            link: route.billing,
            icon: <IoMdPeople />,
          },
          {
            label: "Credits",
            link: route.credits,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Help & Support",
        icon: "ti ti-help",
        submenu: false,
        showSubRoute: false,
        link: route.myTickets,
      },

      {
        label: "Power Dialer",
        icon: "ti ti-phone-call",
        submenu: true,
        showSubRoute: true,
        submenuItems: [
          {
            label: "Lists",
            link: route.powerDialerLists,
            icon: <IoMdPeople />,
          },
          {
            label: "Campaigns",
            link: route.powerDialer,
            icon: <IoMdPeople />,
          },
        ],
      },

    ],
  },
];
